import useTaskAttachedPerspectives from './useTaskAttachedPerspectives';
import CardPerspectiveAndWorldIndicators from '../../../perspectives/CardPerspectiveAndWorldIndicators';
import { type TaskSummary } from '@/lib/types';

type TaskCardPerspectiveAndWorldIndicatorsProps = {
  task: TaskSummary;
};

const TaskCardPerspectiveAndWorldIndicators = ({
  task,
}: TaskCardPerspectiveAndWorldIndicatorsProps) => {
  const attachedPerspectives = useTaskAttachedPerspectives(task);

  if (attachedPerspectives.length === 0 && task.worlds.length === 0) {
    return null;
  }

  return (
    <CardPerspectiveAndWorldIndicators
      perspectives={attachedPerspectives}
      worlds={task.worlds}
    />
  );
};

export default TaskCardPerspectiveAndWorldIndicators;
